export default __webpack_public_path__ + "static/media/b-p2p-a.766afda6.svg";